import { render, staticRenderFns } from "./buy-drawer.vue?vue&type=template&id=627bd54e&scoped=true"
import script from "./buy-drawer.vue?vue&type=script&lang=js"
export * from "./buy-drawer.vue?vue&type=script&lang=js"
import style0 from "./buy-drawer.vue?vue&type=style&index=0&id=627bd54e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627bd54e",
  null
  
)

export default component.exports